import Configuration from '../Configuration';

export const isEmptyMixin = {
	methods: {
		isEmpty(obj) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) return false;
			}
			return true;
		},
	},
};

// parse date that comes back from dynamics in readable format
export const parseDateMixin = {
	methods: {
		parseDate(dateStamp) {
			let monthNames = [
				'January',
				'February',
				'March',
				'April',
				'May',
				'June',
				'July',
				'August',
				'September',
				'October',
				'November',
				'December',
			];
			let date = new Date(dateStamp);
			let month = date.getMonth();
			let monthName = monthNames[month];
			let dayNumber = date.getDate();
			let year = date.getFullYear();
			return monthName + ' ' + dayNumber + ', ' + year;
		},
	},
};

// calculate image url string to be responsive
// Available Parameters:
//  - w: Optional - Desired Width of the image
//  - h: Optional - Desired Height of the image
//  - type=crop - Optional - if both w and h are provided, crop can be added to return the cropped image

// Example: <img src='<ALPHA_API_ENDPOINT>/media/fetch/:zuid?w=50&h=50&type=crop' />
//  - :zuid is the ppd_zestyguid provided by the image object from dynamics
//  - w is a number representing the desired width of the image (optional)
//  - h is a number represinting the desired height of the image (optional)
//  - type only has one option: crop (also optional, just omit the whole param)
//  - w and h, minimum of 50, maximum of 2000
//  - if both w and h aren't provided, type will be ignored
//  - alternatively, if w or h are provided in a non integer format it will default to w=500
//  - if neither w nor h are provided, default of w=750 will be assumed
//  - non recognized parameters are ignored
export const calcRespImageURLMixin = {
	methods: {
		calcRespImageURL(zestyImageGUID, width, height) {
			const baseHostURL = window.location.origin;

			let baseApiURL = process.env.VUE_APP_API_ENDPOINT;
			let mediaFetchURL = `/media/fetch/` + zestyImageGUID + `?`;

			if(process.env.VUE_APP_ZESTY_ENV === 'production' && baseHostURL === 'https://t0sxcdwl-dev.preview.zestyio.com' ) {
				baseApiURL = `https://api-stage.alphauniverse.com`;
			}

      baseApiURL = Configuration.currentConfiguration().VUE_APP_API_ENDPOINT;

			let fullBaseURL = baseApiURL + mediaFetchURL;

			if (width && !height) {
				fullBaseURL += `w=` + width;
			}
			if (height && !width) {
				fullBaseURL += `h=` + height;
			}
			if (width && height) {
				fullBaseURL += `w=` + width + `&` + `h=` + height;
			}

			return fullBaseURL;
		},
		// the API answers an unknown ZUID with its placeholder image
		imagePlaceholderURL(width) {
			return this.calcRespImageURL('undefined', width);
		},
		// Prefer direct CDN/S3 URL (ppd_imageurl); fall back to legacy /media/fetch/:zuid.
		// New uploads often have a working imageurl while fetch-by-zuid still returns the Alpha placeholder.
		resolveMediaImageURL(imageUrl, zestyImageGUID, width, height) {
			if (imageUrl) {
				return imageUrl;
			}
			if (zestyImageGUID) {
				return this.calcRespImageURL(zestyImageGUID, width, height);
			}
			return this.imagePlaceholderURL(width);
		},
		// <img @error="onRespImageError($event, 500)">: /media/fetch now 302s to the CDN, which can still fail
		onRespImageError(event, width) {
			const img = event && event.target;
			if (!img || img.dataset.placeholder) {
				return;
			}
			img.dataset.placeholder = 'true';
			img.removeAttribute('srcset');
			img.src = this.imagePlaceholderURL(width);
		},
		// CSS backgrounds can't use onerror; the placeholder layer shows if the photo layer fails
		respBackgroundImage(zestyImageGUID, width, height) {
			return `url(${this.calcRespImageURL(zestyImageGUID, width, height)}), url(${this.imagePlaceholderURL(width)})`;
		},
		// Same as respBackgroundImage, but prefers ppd_imageurl when present
		respMediaBackgroundImage(imageUrl, zestyImageGUID, width, height) {
			const primary = this.resolveMediaImageURL(imageUrl, zestyImageGUID, width, height);
			return `url(${primary}), url(${this.imagePlaceholderURL(width)})`;
		},
	},
};
